import { useEffect, useRef } from "react";

const useKonamiCode = (props) => {
  const { handleOpen } = props;

  const konamiCode = [
    "ArrowUp",
    "ArrowUp",
    "ArrowDown",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "ArrowLeft",
    "ArrowRight",
    "b",
    "a",
  ];
  const konamiCodePosition = useRef(0);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === konamiCode[konamiCodePosition.current]) {
        konamiCodePosition.current += 1;
        if (konamiCodePosition.current === konamiCode.length) {
          handleOpen();
          konamiCodePosition.current = 0;
        }
      } else {
        konamiCodePosition.current = 0;
      }
    };

    globalThis.addEventListener("keydown", handleKeyDown);
    return () => {
      globalThis.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleOpen]);
};

export default useKonamiCode;
